import React from 'react';
import TemplateContainer from '../Containers/TemplateContainer/TemplateContainer';

const TemplatePage = () => {
  return (
    <TemplateContainer/>
  )
}

export default TemplatePage;